import isNotUndefinedOrNull from '@zenbusiness/application-commons-utils/isNotUndefinedOrNull';
import Chip from '@zenbusiness/zui/Chip';
import Heading from '@zenbusiness/zui/Heading';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import useBreakpoints from '#client/hooks/useBreakpoints';

import { IconWrapper, MoneyTrendWarper } from './MoneyTrend.styles';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

export default function MoneyTrend({ title, amount, description, loading, srcIcon }) {
  const hasAmount = isNotUndefinedOrNull(amount);
  const formattedAmount = hasAmount ? formatter.format(amount / 100) : 'no data';
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <MoneyTrendWarper
      // borderRadius={{ xs: '12px', md: '16px' }}
      flexGrow={1}
      gap={{ xs: '8px', md: '16px' }}
      minHeight={{ xs: 112, md: 160 }}
      p={{ xs: '16px', md: '24px' }}
    >
      <IconWrapper>
        <SharedAsset
          alt=""
          height={isDesktop ? 27 : 21}
          src={srcIcon}
          width={isDesktop ? 27 : 21}
        />
      </IconWrapper>
      <Text
        color="primary"
        size="md"
        weight="medium"
      >
        {title}
      </Text>
      <Heading
        color={hasAmount ? 'primary' : 'tertiary'}
        size="2xl"
        weight="bold"
      >
        {loading ? (
          <Skeleton
            aria-label="Loading value"
            width="75%"
          />
        ) : (
          formattedAmount
        )}
      </Heading>
      <Chip
        icon={
          <SharedAsset
            alt=""
            src="/s2/icon/calendar-date-fill.svg"
          />
        }
        sx={{
          width: 'max-content'
        }}
      >
        <Text
          color="primary"
          size="sm"
        >
          {description}
        </Text>
      </Chip>
    </MoneyTrendWarper>
  );
}

MoneyTrend.propTypes = {
  title: PropTypes.string.isRequired,
  amount: PropTypes.number,
  description: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  srcIcon: PropTypes.string.isRequired
};
